import React from 'react'
import { DumbField } from "components/Wizard2/Field"
import {
  Checkbox,
  RadioInput,
  Select
} from "components/Wizard2/fieldComponents/Form"
import DateRange from "components/Wizard2/fieldComponents/DateRange"
import { noop } from "utilities"

export default class FilterPopout extends React.Component {
  setValue = (value, key, props = {}) => {
    this.props.onChange(
      {
        ...this.props.filters,
        [key]: value,
      },
      props
    )
  }

  render() {
    const { onRequestClose, filters = {}, filterTemplates = [] } = this.props
    const mergedFilters = filterTemplates.map((ft) => ({
      ...ft,
      value: filters[ft.name] !== undefined ? filters[ft.name] : ft.defaultValue,
    }))

    return (
      <React.Fragment>
        <div className="filter-popout wizard">
          <h3>Filters</h3>
          {mergedFilters.map((f) => {
            switch (f.type) {
              case 'radio':
                return (
                  <DumbField label={f.label} key={f.name}>
                    <RadioInput
                      onChange={(value) => {
                        this.setValue(value, f.name)
                      }}
                      options={f.options}
                      value={f.value}
                    />
                  </DumbField>
                )
              case 'select':
                return (
                  <DumbField label={f.label} key={f.name}>
                    <Select
                      onChange={(value) => {
                        this.setValue(value, f.name)
                      }}
                      onBlur={noop}
                      options={f.options}
                      value={f.value}
                    />
                  </DumbField>
                )
              case 'dateRange':
                return (
                  <DumbField className="date-range" label={f.label} key={f.name} ownsLabel>
                    <div className="date-range-wrapper">
                      <DateRange
                        stacked
                        onChange={(value) => {
                          this.setValue(value, f.name, { getRecords: false })
                        }}
                        onBlur={() => {
                          this.setValue(f.value, f.name)
                        }}
                        onButtonClicked={(value) => {
                          this.setValue({...f.value, ...value}, f.name)
                        }}
                        value={f.value}
                        startLabel="Start"
                        endLabel="End"
                        ownsLabel
                        label={f.label}
                      />
                    </div>
                  </DumbField>
                )
              case 'checkbox':
                return (
                  <DumbField className="checkbox" key={f.name}>
                    <Checkbox
                      name={f.name}
                      onChange={(value) => {
                        this.setValue(value, f.name)
                      }}
                      value={f.value}
                      label={f.label}
                    />
                  </DumbField>
                )
              default:
                return null
            }
          })}
        </div>
        <div
          className="filter-popout-shade animated fadeIn extra-fast-animation"
          onClick={onRequestClose}
        />
      </React.Fragment>
    )
  }
}
